import { render } from "./EmailBrowser.vue?vue&type=template&id=4f84bd11&scoped=true"
import script from "./EmailBrowser.vue?vue&type=script&lang=js"
export * from "./EmailBrowser.vue?vue&type=script&lang=js"

import "./EmailBrowser.vue?vue&type=style&index=0&id=4f84bd11&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f84bd11"]])

export default __exports__